module.exports = __webpack_public_path__ + "static/media/arrow_left.958b4514.svg";